export var validatePassword = function (password) { return ({
    pwdLength: password.length >= 8,
    pwdCapital: /[A-Z]/.test(password),
    pwdNonCapital: /[a-z]/.test(password),
    pwdNumber: /\d/.test(password),
    pwdSpecial: /[~\-!@#$%^&*.]/.test(password),
}); };
export var isPasswordValid = function (password) {
    return Object.values(validatePassword(password)).every(Boolean);
};
